import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import * as styles from './ContentWithStickyColumn.module.scss'
import Container from '../container/Container'

function ContentWithStickyColumn({
  children,
  info,
  title,
  className,
  ...rest
}) {
  return (
    <section className={classNames(styles.section, className)} {...rest}>
      {title && <h1 className={styles.title}>{title}</h1>}
      <Container className={styles.container}>
        <div className={styles.stick}>
          <div className={styles.info}>{info}</div>
        </div>

        <div className={styles.content}>{children}</div>
      </Container>
    </section>
  )
}

ContentWithStickyColumn.propTypes = {
  children: PropTypes.node.isRequired,
  info: PropTypes.node.isRequired,
  title: PropTypes.string,
  className: PropTypes.string,
}

export default ContentWithStickyColumn
